export function formatSize(bytes: number): string {
    if (!bytes || isNaN(bytes)) return "–";
    const thresh = 1024;
    const units = ["B", "KB", "MB", "GB", "TB", "PB"];
    let i = 0;
    while (bytes >= thresh && i < units.length - 1) {
      bytes /= thresh;
      i++;
    }
    return `${bytes.toFixed(i === 0 ? 0 : 2)} ${units[i]}`;
}
